import {MMQueryOptions} from 'lionheartland';


export class SODeleteAlertSubscription {

  constructor(
    public uid: string,
    public predicate: string = null,
    public queryOptions: MMQueryOptions = new MMQueryOptions(),
  ) {
  }
}
